import React from 'react'
import Styles from './overviewStyles.module.css';
import Tile from '../../../Tile/Tile';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {Actions} from '../../../../Action/index';
export default function Tiles() {
  const state = useSelector(state=>state.cmOverview);
  const dispatch = useDispatch();
  const {crossnavigationAnswered,crossnavigationNotAnswered} = bindActionCreators(Actions, dispatch)
  const navigate = useNavigate();
  const crossNavigation = (key)=>{
    if(key === "answered"){
      crossnavigationAnswered(1);
    }
    if(key === "not_answered"){
      crossnavigationNotAnswered(2);
    }
    // navigate(`/cmHome/expertRecords/`);
    navigate(`/cmHome/expertResponses/`);
    return;
  }
  return (
    <>
  <Spin spinning={state.isCountLoading}>
    <div style={{borderRadius:'6px',boxShadow:'5px 5px 15px rgba(0, 0, 0, 0.1)'}}>
    <div className={Styles.tilesContainer}>
        <div style={{minWidth:'20%'}}>
        <Tile color={'#20a8d8'} title={'Total Views'} icon="fa fa-question-circle" data="totalViews" />
        </div>
        <div style={{minWidth:'20%'}}>
        <Tile color={'#4ab319'} title={'Total Searches'} icon="fa fa-area-chart" data="totalSearched" />
        </div>
        <div style={{minWidth:'20%', cursor:'pointer'}} onClick={()=>crossNavigation("answered")}>
        <Tile color={'#7986CB'} title={'Total Answers'} icon="fa fa-search" data="questionsTotalAnswered"  />
        </div>
        <div style={{minWidth:'20%'}}>
        <Tile color={'#42A5F5'} title={'Expert Submitted'} icon="fa fa-check-circle" data="totalSubmitted"/>
        </div>
        <div style={{minWidth:'20%', cursor:'pointer'}} onClick={()=>crossNavigation("not_answered")}>
        <Tile color={'#f86c6b'} title={'Unanswered Questions'} icon="fa fa-user" data="unansweredCount"/>
        </div>
    </div>
    <div className={Styles.tilesContainer}>
        {/* <div style={{minWidth:'20%'}}>
        <Tile icon="fa fa-clock-o" color={'#90A4AE'} title={'Deflection Rate %'} data="deflectionRate"/>
        </div> */}
        {/* <div style={{minWidth:'20%'}}>
        <Tile icon="fa fa-clock-o" color={'#ffc107'} title={'Response Time'} data="avgRespTime"/>
        </div>  */}
          <div style={{minWidth:'20%'}}>
        <Tile icon="fa fa-clock-o" color={'#ffc107'} title={'First Response'} data="firstAvgRespTime"/>
        </div>
        <div style={{minWidth:'20%'}}>
        <Tile icon="fa fa-clock-o" color={'#ffc107'} title={'Median Response'} data="avgRespTime"/>
        </div>
        {/* <div style={{minWidth:'20%'}}>
        <Tile icon="fa fa-line-chart" color={'#90A4AE'} data="deflectionRate" title={'Deflection Rate %'}/>
        </div> */}
        <div style={{minWidth:'20%'}}>
        <Tile icon="fa fa-pie-chart" color={'#F9812A'} data="domains" title={'Domain Count'}/>
        </div>
        <div style={{minWidth:'20%'}}>
        <Tile icon="fa fa-users" color={'#ff1476'} title={'Users Type'} data="employeeCount"/>
        </div>
        <div style={{minWidth:'20%'}}>
        <Tile icon="fa fa-users" color={'#f86c6b'} title={'Active Users'} data="activeCount"/>
        </div>
    </div>
    </div>
    </Spin>
    </>
  )
}
